import { isEmpty } from 'radash';

import { AccordionItem } from '@/components/core/Accordion';
import { CategoryComponent } from '@/components/datamodel/Category/Category';
import { useLayout } from '@/components/datamodel/hooks/useLayout';
import { useAuth } from '@/hooks/useAuth';
import { useDataModel } from '@/hooks/useDataModel';
import { useTranslation } from '@/hooks/useTranslation';
import { DataModelCategory } from '@/types/DataModel';

import { SectionAccordionContent } from './SectionAccordionContent';
import { SectionAccordionTrigger } from './SectionAccordionTrigger';

interface CategorySectionProps {
    initialSelectedCategory?: string;
    isNewItem: boolean;
    categories: DataModelCategory[] | undefined;
}

const CategorySection = ({ initialSelectedCategory, isNewItem, categories }: CategorySectionProps) => {
    const { t } = useTranslation();
    const { layout } = useLayout();
    const { dataModel } = useDataModel();
    const { auth } = useAuth();

    // We hide the category section if we are editing an item
    // and the layout specifies that we should hide it.
    if ((layout?.layoutOptions?.hideCategorySection && !isNewItem) || !dataModel || !auth) {
        return null;
    }

    if (categories && categories.length == 1 && !isEmpty(categories[0].name)) {
        return;
    }

    return (
        <AccordionItem value="category" className="react-panel">
            <SectionAccordionTrigger translatedSectionName={t('CATEGORY')} section={{
                label: 'CATEGORY',
                model_defined: false,
                name: 'CATEGORY',
                attributes: [],
            }} />
            <SectionAccordionContent isOpen keepMounted>
                <CategoryComponent
                    initialSelectedCategory={initialSelectedCategory}
                    isNewItem={isNewItem}
                />
            </SectionAccordionContent>
        </AccordionItem>
    );
};

CategorySection.DisplayName = 'CategorySection';

export { CategorySection };
